import memoizeOne from "memoize-one";

// set below to https://0e8dsk2on2.execute-api.eu-west-2.amazonaws.com/VbTPa9EPbaYAtmnesKFmbS or http://localhost:8080/local for testing against staging
let TEMP_API_URL = null;

const getAPIBaseURL = (windowHostname) => {
    let baseURL = "https://api.aivr-dev.video";
    if (windowHostname === "view.aivr.video") {
        baseURL = "https://api.aivr.video";
    } else if (windowHostname === "view-dev.aivr.video") {
        baseURL = "https://api-dev.aivr.video";
    } else if (windowHostname === "view-test.aivr.video" || windowHostname === "test.localhost") {
        baseURL = "https://api-test.aivr.video";
    } else if (windowHostname === "view-widget.aivr.video" || windowHostname === "widget.localhost") {
        baseURL = "https://api-widget.aivr.video";
    } else if (windowHostname === "view-widgetdev.aivr.video" || windowHostname === "widgetdev.localhost") {
        baseURL = "https://api-widgetdev.aivr.video";
    } else if (windowHostname === "view.aivr.au") {
        baseURL = "https://api.aivr.au";
    } else if (windowHostname === "view-dev.aivr.au") {
        baseURL = "https://api-dev.aivr.au";
    } else if (windowHostname === "view.aivr.us") {
        baseURL = "https://api.aivr.us";
    } else if (windowHostname === "view-dev.aivr.us") {
        baseURL = "https://api-dev.aivr.us";
    }

    //To be removed at a later date
    else if (windowHostname === "localhost") {
        baseURL = "https://api-dev.aivr.video";
        if (TEMP_API_URL) {
            baseURL = TEMP_API_URL;
        }
    }

    return baseURL;
};

const getBaseUrl = (windowHostname) => {
    const domain = windowHostname.split(".").slice(-2).join(".");
    let baseURL = ".aivr.video";
    if (domain === "aivr-dev.video") {
        baseURL = ".aivr-dev.video";
    } else if (domain === "aivr.au") {
        baseURL = ".aivr.au";
    } else if (domain === "localhost") {
        baseURL = ".aivr.video";
    } else if (domain === "aivr.us") {
        baseURL = ".aivr.us";
    }
    return baseURL;
};

const getImagePackUrl = (windowHostname) => {
    let imagePackURL = "https://imagepack.aivr.video";
    if (windowHostname === "view.aivr-dev.video") {
        imagePackURL = "https://imagepack.aivr-dev.video";
    } else if (windowHostname === "localhost") {
        imagePackURL = "https://imagepack.aivr-dev.video";
    } else if (windowHostname === "view.aivr.au") {
        imagePackURL = "https://imagepack.aivr.au";
    } else if (windowHostname === "view-dev.aivr.au") {
        imagePackURL = "https://imagepack.aivr.au";
    } else if (windowHostname === "view.aivr.us") {
        imagePackURL = "https://imagepack.aivr.us";
    } else if (windowHostname === "view-dev.aivr.us") {
        imagePackURL = "https://imagepack.aivr.us";
    }

    return imagePackURL;
};

const getMapTileUrl = (windowHostname) => {
    let mapTileURL = "https://tiles.aivr.video";
    if (windowHostname === "view.aivr-dev.video") {
        mapTileURL = "https://tiles.aivr.video";
    } else if (windowHostname === "localhost") {
        mapTileURL = "https://tiles.aivr.video";
    } else if (windowHostname === "view.aivr.au") {
        mapTileURL = "https://tiles.aivr.au";
    } else if (windowHostname === "view-dev.aivr.au") {
        mapTileURL = "https://tiles.aivr.au";
    } else if (windowHostname === "view.aivr.us") {
        mapTileURL = "https://tiles.aivr.us";
    } else if (windowHostname === "view-dev.aivr.us") {
        mapTileURL = "https://tiles.aivr.us";
    }
    return mapTileURL;
};

const memoizedGetBaseUrl = memoizeOne(getBaseUrl);
const memoizedAPIBaseURL = memoizeOne(getAPIBaseURL);
const memoizedImagePackURL = memoizeOne(getImagePackUrl);
const memoizedMapTileURL = memoizeOne(getMapTileUrl);

export const MEMOIZED_DOMAIN_URL = memoizedGetBaseUrl(window.location.hostname);
export const MEMOIZED_API_BASE_URL = memoizedAPIBaseURL(window.location.hostname);
export const MEMOIZED_IMAGEPACK_URL = memoizedImagePackURL(window.location.hostname);
export const MEMOIZED_MAP_TILE_URL = memoizedMapTileURL(window.location.hostname);
